import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map} from "rxjs/operators";
import {EDIT_TXT_ACTION, EditTextActions} from "../actions/edit-text.actions";
import {MatDialog} from "@angular/material/dialog";
import {EditTextDialogComponent} from "../src/lib/dialogs/edit-text/edit-text-dialog.component";

@Injectable()
export class EditTextEffects {
  editText$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<EditTextActions>(EDIT_TXT_ACTION),
        map((action) => {
          if (action.payload) {
            this.openDialog(action.payload);
          }
        })
      ),
    {dispatch: false}
  );

  constructor(private actions$: Actions,
              public dialog: MatDialog) {
  }


  openDialog(node: any): void {
    this.dialog.open(EditTextDialogComponent, {
      data: node,
      width: '800px',
    });
  }
}
